import { render, staticRenderFns } from "./PDPHelpBlock.vue?vue&type=template&id=d00ecf90"
import script from "./PDPHelpBlock.vue?vue&type=script&lang=ts"
export * from "./PDPHelpBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports